import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule,} from '@angular/common/http';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {NgHttpLoaderModule} from 'ng-http-loader';
import {NgxMatTimelineModule} from 'ngx-mat-timeline';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {NgxPermissionsModule, NgxPermissionsService} from 'ngx-permissions';
import {environment} from '../environments/environment';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {GraphQLModule} from './graphql.module';
import {FeedbackComponent} from './guest/feedback/feedback.component';
import {LoginComponent} from './guest/login/login.component';
import {PortalHomeCompanyComponent} from './guest/portal/portal-home-company/portal-home-company.component';
import {PortalHomeComponent} from './guest/portal/portal-home/portal-home.component';
import {PortalComponent} from './guest/portal/portal.component';
import {RegisterComponent} from './guest/register/register.component';
import {ResetPasswordEmailComponent} from './guest/reset-password-email/reset-password-email.component';
import {ResetPasswordComponent} from './guest/reset-password/reset-password.component';
import {UserProfileComponent} from './guest/user-profile/user-profile.component';
import {AuthInterceptor} from './interceptors/auth-interceptor';
import {AuthService} from './services/auth.service';
import {SharedModule} from './shared/shared.module';
import {
  CitizensServicesAutomationDetailsEffects
} from './store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.effects';
import {
  CitizensServicesCategoryEffects
} from './store/entities/citizens/citizens-services-category/citizens-services-category.effects';
import {
  CitizensServicesDeliveryChannelEffects
} from './store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.effects';
import {
  CitizensServicesDeliveryProcedureDiagramEffects
} from './store/entities/citizens/citizens-services-delivery-procedure-diagram/citizens-services-delivery-procedure-diagram.effects';
import {
  CitizensServicesDeliveryProcedureStepsEffects
} from './store/entities/citizens/citizens-services-delivery-procedure-steps/citizens-services-delivery-procedure-steps.effects';
import {
  CitizensServicesExistanceSourceEffects
} from './store/entities/citizens/citizens-services-existance-source/citizens-services-existance-source.effects';
import {
  CitizensServicesGroupsEffects
} from './store/entities/citizens/citizens-services-groups/citizens-services-groups.effects';
import {
  CitizensServicesProvisionMeansEffects
} from './store/entities/citizens/citizens-services-provision-means/citizens-services-provision-means.effects';
import {
  CitizensServicesRequirementsEffects
} from './store/entities/citizens/citizens-services-requirements/citizens-services-requirements.effects';
import {
  CitizensServicesResultEffects
} from './store/entities/citizens/citizens-services-result/citizens-services-result.effects';
import {CitizensServicesEffects} from './store/entities/citizens/citizens-services/citizens-services.effects';
import {
  ApprovalFlowStagesEffects
} from './store/entities/instution-settings/approval-flow-stages/approval-flow-stages.effects';
import {
  ApprovalFlowSuccessorEffects
} from './store/entities/instution-settings/approval-flow-successor/approval-flow-successor.effects';
import {ApprovalFlowEffects} from './store/entities/instution-settings/approval-flow/approval-flow.effects';
import {DesignationEffects} from './store/entities/instution-settings/designation/designation.effects';
import {
  InstutionFunctionEffects
} from './store/entities/instution-settings/instution-function/instution-function.effects';
import {InstutionRoleEffects} from './store/entities/instution-settings/instution-role/instution-role.effects';
import {InstutionUserEffects} from './store/entities/instution-settings/instution-user/instution-user.effects';
import {
  CatalogPayableSchemeEffects
} from './store/entities/service-management/catalog-payable-scheme/catalog-payable-scheme.effects';
import {
  FormulaPayableSchemeEffects
} from './store/entities/service-management/formula-payable-scheme/formula-payable-scheme.effects';
import {
  ServiceAutomationDetailEffects
} from './store/entities/service-management/service-automation-detail/service-automation-detail.effects';
import {
  ServiceBillingDetailEffects
} from './store/entities/service-management/service-billing-detail/service-billing-detail.effects';
import {
  ServiceCatalogSchemeEffects
} from './store/entities/service-management/service-catalog-scheme/service-catalog-scheme.effects';
import {ServiceChannelEffects} from './store/entities/service-management/service-channel/service-channel.effects';
import {
  ServiceDeliveryDurationEffects
} from './store/entities/service-management/service-delivery-duration/service-delivery-duration.effects';
import {
  ServiceDirectCostEffects
} from './store/entities/service-management/service-direct-cost/service-direct-cost.effects';
import {
  ServiceFormulaSchemeEffects
} from './store/entities/service-management/service-formula-scheme/service-formula-scheme.effects';
import {
  ServiceManagementRequirementEffects
} from './store/entities/service-management/service-management-requirement/service-management-requirement.effects';
import {
  ServicePercentageSchemeEffects
} from './store/entities/service-management/service-percentage-scheme/service-percentage-scheme.effects';
import {ServiceEffects} from './store/entities/service-management/service/service.effects';
import {SubServiceEffects} from './store/entities/service-management/sub-service/sub-service.effects';
import {UploadableFormEffects} from './store/entities/service-management/uploadable-form/uploadable-form.effects';
import {CurrencyTypeEffects} from './store/entities/system-settings/currency-type/currency-type.effects';
import {
  InstitutionAdminEffects
} from './store/entities/system-settings/institution/institution-admin/institution-admin.effects';
import {InstitutionEffects} from './store/entities/system-settings/institution/institution.effects';
import {MinistryEffects} from './store/entities/system-settings/ministry/ministry.effects';
import {PermissionEffects} from './store/entities/system-settings/permission/permission.effects';
import {RoleEffects} from './store/entities/system-settings/role/role.effects';
import {SectorEffects} from './store/entities/system-settings/sector/sector.effects';
import {ServiceCategoryEffects} from './store/entities/system-settings/service-category/service-category.effects';
import {
  ServiceRequirementGroupEffects
} from './store/entities/system-settings/service-requirement-group/service-requirement-group.effects';
import {
  ServiceRequirementEffects
} from './store/entities/system-settings/service-requirement/service-requirement.effects';
import {metaReducers, reducers} from './store/reducers';
import {
  ServiceChangeRequestEffects
} from "./store/entities/service-management/service-change-request/service-change-request.effects";
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {ServiceHeaderComponent} from './guest/portal/service-header/service-header.component';
import {RequestFormsComponent} from './guest/portal/service-view/request-forms/request-forms.component';
import {ServiceViewComponent} from './guest/portal/service-view/service-view.component';
import {VerifyPhoneNumberComponent} from './guest/register/citizen/verify-phone-number/verify-phone-number.component';
import {
  CitizenGetAllFeedbackCategoriesEffects
} from './store/entities/citizens/citizen-get-all-feedback-categories/citizen-get-all-feedback-categories.effects';
import {
  CitizenVerifyOptNumberEffects
} from './store/entities/citizens/register/citizen-verify-opt-number/citizen-verify-opt-number.effects';
import {
  CitizenVerifyPasswordEffects
} from './store/entities/citizens/register/citizen-verify-password/citizen-verify-password.effects';
import {
  CitizenVerifyPhoneNumberEffects
} from './store/entities/citizens/register/citizen-verify-phone-number/citizen-verify-phone-number.effects';
import {CreateUsersEffects} from './store/entities/citizens/register/create-users/create-users.effects';
import {
  UpdateCitizenPasswordEffects
} from './store/entities/citizens/register/update-citizen-password/update-citizen-password.effects';
import {FeedbackCategoryEffects} from './store/entities/feedback-category/feedback-category.effects';
import {FeedbackEffects} from './store/entities/feedback/feedback.effects';
import {MediaImageEffects} from './store/entities/media-image/media-image.effects';
import {ApprovedServiceEffects} from './store/entities/service-management/approved-service/approved-service.effects';
import {FormFieldOptionEffects} from './store/entities/service-management/form-field-option/form-field-option.effects';
import {FormResponseEffects} from './store/entities/service-management/form-response/form-response.effects';
import {
  ServiceApprovalFlowEffects
} from './store/entities/service-management/service-approval-flow/service-approval-flow.effects';
import {
  UploadableFormAttachmentEffects
} from './store/entities/service-management/uploadable-form-attachment/uploadable-form-attachment.effects';
import {
  CitizenServicesResultsComponent
} from './guest/portal/citizens/citizen-services-results/citizen-services-results.component';
import {
  CitizenServicesAutomationDetailsComponent
} from './guest/portal/citizens/citizen-services-automation-details/citizen-services-automation-details.component';
import {
  CitizenServicesProvicionMeansComponent
} from './guest/portal/citizens/citizen-services-provicion-means/citizen-services-provicion-means.component';
import {
  CitizenServicesDeliveryChannelComponent
} from './guest/portal/citizens/citizen-services-delivery-channel/citizen-services-delivery-channel.component';
import {
  CitizenServicesServiceGroupComponent
} from './guest/portal/citizens/citizen-services-service-group/citizen-services-service-group.component';
import {
  CitizensServicesSectorEffects
} from './store/entities/citizens/citizens-services-sector/citizens-services-sector.effects';

import {
  CitizensGroupSummariesEffects
} from './store/entities/citizens/citizens-group-summaries/citizens-group-summaries.effects';
import {
  CitizensProvidersSummariesEffects
} from './store/entities/citizens/citizens-providers-summaries/citizens-providers-summaries.effects';
import {
  CitizensFreeServicesSummariesEffects
} from './store/entities/citizens/citizens-free-services-summaries/citizens-free-services-summaries.effects';
import {FillableFormEffects} from './store/entities/service-management/fillable-form/fillable-form.effects';
import {
  FillableFormFieldEffects
} from './store/entities/service-management/fillable-form-field/fillable-form-field.effects';
import {SampleFormEffects} from './store/entities/service-management/sample-form/sample-form.effects';
import {ProcedureDiagramEffects} from './store/entities/service-management/procedure-diagram/procedure-diagram.effects';
import {
  CitizensUploadableFormRequestEffects
} from './store/entities/citizens/citizens-uploadable-form-request/citizens-uploadable-form-request.effects';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatSidenavModule} from '@angular/material/sidenav';
import {NotificationCenterComponent} from './modules/settings/notification-center/notification-center.component';
import {
  ServiceSocialGroupEffects
} from './store/entities/service-management/service-social-group/service-social-group.effects';
import {BranchOfficeEffects} from './store/entities/instution-settings/branch-office/branch-office.effects';
import {RegionsEffects} from './store/entities/locations/regions/regions.effects';
import {DistrictsEffects} from './store/entities/locations/districts/districts.effects';
import {WardsEffects} from './store/entities/locations/wards/wards.effects';
import {StreetsEffects} from './store/entities/locations/streets/streets.effects';
import {
  ServiceBranchOfficeEffects
} from './store/entities/service-management/service-branch-office/service-branch-office.effects';
import {ContactUsComponent} from './guest/portal/contact-us/contact-us.component';
import {PrivacyPolicyComponent} from './guest/portal/privacy-policy/privacy-policy.component';
import {TermsConditionsComponent} from './guest/portal/terms-conditions/terms-conditions.component';
import {
  FrequentlyAskedQuestionComponent
} from './guest/portal/frequently-asked-question/frequently-asked-question.component';
import {
  CollaborationReasonEffects
} from './store/entities/system-settings/collaboration-reason/collaboration-reason.effects';
import {
  ServiceCollaborationEffects
} from './store/entities/service-management/service-collaboration/service-collaboration.effects';
import {
  InstitutionServicesSummaryEffects
} from './store/entities/service-management/institution-services-summary/institution-service-summary.effects';
import {provideNgxMask} from 'ngx-mask';
import {LoadingBarHttpClientModule} from "@ngx-loading-bar/http-client";
import {LoadingBarModule} from "@ngx-loading-bar/core";
import {ActivateAccountComponent} from "./guest/activate-account/activate-account.component";
import {ActivateAccountEffects} from './store/entities/uaa-setting/activate-account/activate-account.effects';
import {StoreItemEffects} from "./store/entities/store-item/store-item.effects";
import {
  CitizensFillableFormResponseEffects
} from "./store/entities/citizens/citizens-fillable-form-response/citizens-fillable-form-response.effects";
import {NgApexchartsModule} from "ng-apexcharts";
import {
  ServiceRequestedChangeEffects
} from "./store/entities/service-management/service-requested-change/service-requested-change.effects";
import {
  ServiceChangeRequestReviewEffects
} from './store/entities/service-management/service-change-request-review/service-change-request-review.effects';
import {UserManagementEffects} from './store/entities/system-settings/user-management/user-management.effects';
import {SystemNamesEffects} from './store/entities/instution-settings/system-names/system-names.effects';
import {
  MyRequestedServicesEffects
} from './store/entities/citizens/my-requested-services/my-requested-services.effects';
import {
  FormFixedResponseEffects
} from './store/entities/service-management/form-fixed-response/form-fixed-response.effects';
import {CitizensEffects} from './store/entities/citizens/register/citizens/citizens.effects';
import {
  FrequentlyAskedQuestionEffects
} from './store/entities/frequently-asked-question/frequently-asked-question.effects';
import {TranslationEffects} from "./store/entities/system-settings/translation/translation.effects";
import {CustomTranslateLoader} from "./services/custom-translate-loader";
import {Apollo} from "apollo-angular";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import {ChangePasswordComponent} from "./guest/change-password/change-password.component";
import ServicesByServiceGroupsComponent from './guest/portal/citizens/services-new-searches/services-by-service-groups/services-by-service-groups.component';
import {NewsDetailPageComponent} from './guest/portal/citizens/news-detail-page/news-detail-page.component';
import {AllServicesComponent} from './guest/portal/citizens/services-new-searches/all-services/all-services.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PortalHomeComponent,
    PortalComponent,
    RegisterComponent,
    FeedbackComponent,
    PortalHomeCompanyComponent,
    ResetPasswordEmailComponent,
    UserProfileComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    CitizenServicesAutomationDetailsComponent,
    CitizenServicesResultsComponent,
    CitizenServicesDeliveryChannelComponent,
    CitizenServicesProvicionMeansComponent,
    CitizenServicesServiceGroupComponent,
    VerifyPhoneNumberComponent,
    ServiceViewComponent,
    RequestFormsComponent,
    ServiceHeaderComponent,

    NotificationCenterComponent,
    ContactUsComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    FrequentlyAskedQuestionComponent,

    ActivateAccountComponent,
    ServicesByServiceGroupsComponent,
    NewsDetailPageComponent,
    AllServicesComponent,

  ],
  imports: [
    BrowserModule,
    FormsModule,
    MatSidenavModule,
    NgxMaterialTimepickerModule,
    CommonModule,
    GraphQLModule,
    HttpClientModule,
    NgxMatTimelineModule,
    AppRoutingModule,
    PdfViewerModule,
    NgApexchartsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [Apollo]
      }
    }),
    NgbModule,
    LoadingBarHttpClientModule,
    LoadingBarModule,
    SharedModule,
    BrowserAnimationsModule,
    EffectsModule.forRoot([
      ServiceCategoryEffects,
      InstutionFunctionEffects,
      ApprovalFlowEffects,
      ServiceEffects,
      CurrencyTypeEffects,
      ServiceAutomationDetailEffects,
      ApprovalFlowStagesEffects,
      ApprovalFlowSuccessorEffects,
      DesignationEffects,
      ServiceDeliveryDurationEffects,
      ServiceChannelEffects,
      ServiceManagementRequirementEffects,
      InstutionUserEffects,
      ServiceBillingDetailEffects,
      ServiceDirectCostEffects,
      ServicePercentageSchemeEffects,
      InstutionRoleEffects,
      CitizensServicesEffects,
      CitizensServicesCategoryEffects,
      CitizensServicesGroupsEffects,
      CitizensServicesRequirementsEffects,
      CitizensServicesAutomationDetailsEffects,
      CitizensServicesProvisionMeansEffects,
      CitizensServicesExistanceSourceEffects,
      CitizensServicesDeliveryProcedureStepsEffects,
      CitizensServicesDeliveryProcedureDiagramEffects,
      CitizensServicesDeliveryChannelEffects,
      CitizensServicesResultEffects,
      ServiceFormulaSchemeEffects,
      FormulaPayableSchemeEffects,
      CatalogPayableSchemeEffects,
      ServiceCatalogSchemeEffects,
      CitizensServicesSectorEffects,
      CitizensGroupSummariesEffects,
      CitizensProvidersSummariesEffects,
      CitizensFreeServicesSummariesEffects,
      UploadableFormEffects,
      SubServiceEffects,
      FillableFormEffects,
      FillableFormFieldEffects,
      SampleFormEffects,
      ProcedureDiagramEffects,
      CitizenVerifyPhoneNumberEffects,
      CitizenVerifyOptNumberEffects,
      CreateUsersEffects,
      CitizenVerifyPasswordEffects,
      UpdateCitizenPasswordEffects,
      UploadableFormAttachmentEffects,
      ServiceApprovalFlowEffects,
      ApprovedServiceEffects,
      CitizenGetAllFeedbackCategoriesEffects,
      CitizensUploadableFormRequestEffects,
      ServiceSocialGroupEffects,
      BranchOfficeEffects,
      RegionsEffects,
      DistrictsEffects,
      WardsEffects,
      StreetsEffects,
      ServiceBranchOfficeEffects,
      CollaborationReasonEffects,
      ServiceCollaborationEffects,
      InstitutionServicesSummaryEffects,
      ServiceChangeRequestEffects,
      StoreItemEffects,
      ServiceChangeRequestEffects,
      ActivateAccountEffects,
      StoreItemEffects,
      CitizensFillableFormResponseEffects,
      ServiceRequestedChangeEffects,
      ServiceChangeRequestReviewEffects,
      UserManagementEffects,
      SystemNamesEffects,
      MyRequestedServicesEffects,
      FormFixedResponseEffects,
      CitizensEffects,
    ]),
    NgxPermissionsModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    StoreModule.forRoot(reducers, {metaReducers}),
    NgHttpLoaderModule.forRoot(),
    EffectsModule.forFeature([
      InstitutionEffects,
      SectorEffects,
      MinistryEffects,
      InstitutionAdminEffects,
      RoleEffects,
      PermissionEffects,
      ServiceRequirementGroupEffects,
      ServiceRequirementEffects,
      FeedbackCategoryEffects,
      FeedbackEffects,
      MediaImageEffects,
      FormResponseEffects,
      FormFieldOptionEffects,
      TranslationEffects,
      FrequentlyAskedQuestionEffects,
    ]),
    NgOptimizedImage,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
  ],
  providers: [
    DatePipe,
    provideNgxMask(),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    NgxPermissionsService,
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => {
        return async () => {
          if (!auth.isCompany()) await auth.authRole();
        };
      },
      deps: [AuthService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [
    RequestFormsComponent,

  ]
})
export class AppModule {
}
